import React from "react";
import "./style.css";
import siteUrl from "./../../siteUrl";
import imageUrl from "../../imageUrl";
import logoVR from "./logo-vr.svg";

const CardHomeType = (props) => {
  const { data } = props;
  return (
    // <a className="card-home-type" href={`${siteUrl}/hometype/${data.url}`}>
    <a
      className={`card-home-type ${data.visualUrl == "#" && "comingsoon"}`}
      href={data.visualUrl}
      target="_blank"
    >
      {/* <img src={`${siteUrl}${data.image}`} alt={data.name} /> */}
      <img src={`${imageUrl}${data.image}`} alt={data.name} />
      <div className="card-detail">
        <div className="home-name">
          {data.name} {data.visualUrl == "#" && "[Coming soon]"}
        </div>
        <div className="home-headline">360 ํ Virtual Home</div>
        <div className="home-logovr">
          <img src={logoVR} alt="logovr" />
        </div>
      </div>
    </a>
  );
};
export default CardHomeType;
